const ApplyingToJoin = {
  EXISTING_AR: "An Existing Appointed Representative",
  NEW_AR: "A New Appointed Representative",
  TRADING_STYLE: "Trading Style",
};

export default ApplyingToJoin;
